/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SettingManagementCreateSettingRequest = {
    category: SettingManagementCreateSettingRequest.category;
    addr: string;
    context: string;
    contextEn?: string;
    contextCn?: string;
};

export namespace SettingManagementCreateSettingRequest {

    export enum category {
        BREEDER = 'breeder',
        VARIETY = 'variety',
        PARENT_CARP = 'parent_carp',
        NOTE = 'note',
        AWARD_TITLE = 'award_title',
        AWARD_GROUP = 'award_group',
        OWNER = 'owner',
    }


}

